export const FONT_TYPE_INDEX = 0;
export const FONT_SIZE_INDEX = 1;
export const FONT_WEIGHT_INDEX = 2;
